import { axiosAPIClient } from './axios';

window.initSafePasswordField = ({ fieldId, defaultGroupType = null, defaultUserUuid = null }) => {
  const $field = $(`#${fieldId}`);
  const $refield = $(`#${fieldId}-repassword`);
  const $passMessageMatching = $('#pass_message_matching');
  const $msg = $('#msg');
  let groupType = defaultGroupType;
  let userUuid = defaultUserUuid;

  function hasPassword() {
    return !!$field.val();
  }

  function setGroupType(type) {
    groupType = type;
  }

  function setUserUuid(uuid) {
    userUuid = uuid;
  }

  function setMessage(html) {
    $msg.html(html);
  }

  async function verifyPassword(forForm, rulesOnly) {
    const password = $field.val();
    if (password.length === 0) {
      if ($field.attr('required')) {
        if (!rulesOnly) {
          setMessage(i18n('password.enter_a_password'));
        }

        return false;
      }

      return true;
    }

    const { data } = await axiosAPIClient.post('/checkPassword', {
      password,
      group_type: groupType || undefined,
      user_uuid: userUuid || undefined,
    });

    if (!forForm || rulesOnly) {
      setMessage(data && data.checks
        ? data.checks.filter(c => !c.fulfilled).map(c => c.text).join('<br>')
        : '');
    }

    return data && data.valid;
  }

  function focusPasswordElement() {
    $field.focus();
  }

  async function checkCurrentPassword(rules_only = false) {
    const result = await verifyPassword(true, rules_only);
    if (!result && !rules_only) {
      setMessage(i18n('password.guidelines_not_met'));
      focusPasswordElement();
    }

    return result;
  }

  async function checkSubmit() {
    const password = $field.val();
    const repassword = $refield.val();
    const guidelinesMet = password && await checkCurrentPassword(false);
    let passwordValid = true;

    if (guidelinesMet) {
      setMessage('');
    } else {
      passwordValid = false;
    }

    if (password && $refield.length > 0 && password !== repassword) {
      focusPasswordElement();
      $passMessageMatching
        .addClass('error-message')
        .removeClass('hidden');
      passwordValid = false;
    } else {
      $passMessageMatching
        .addClass('hidden')
        .removeClass('error-message');
    }

    return passwordValid;
  }

  $field.on('keyup', () => verifyPassword(false, false));

  window.safePasswordField = {
    hasPassword,
    setGroupType,
    setUserUuid,
    checkCurrentPassword,
    checkSubmit,
  };
};
